import { IHttpClient } from '@/core/services/http'
import { AccountType } from '@/core/types/enums/account-type.enum'
import { cityResolver } from '../resolvers/city.resolver'
import { LocationInfoResponse } from '../types/api-responses/location-info.response'
import { AirportModel } from '../types/models/airport.model'

type Params = {
  latitude: number
  longitude: number
}

export function createGetLocationInfoUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function (
    { latitude, longitude }: Params,
    { controller }: { controller?: AbortController } = {},
    accountType = AccountType.CUSTOMER,
  ) {
    const res = await httpClient.version('v1').post<{
      data: LocationInfoResponse
    }>(
      `/website/${accountType}/getLocationInfo`,
      { latitude, longitude },
      {
        signal: controller?.signal,
      },
    )

    return resolver(res.data.data)
  }
}

function resolver(location: LocationInfoResponse): AirportModel {
  const place = location.results[0]

  return {
    address: place.formatted_address,
    latitude: place.geometry.location.lat.toString(),
    longitude: place.geometry.location.lng.toString(),
    place_id: place.place_id,
    types: place.types,
    name:
      place.formatted_address ||
      place.address_components?.[0]?.long_name ||
      place.address_components?.[1]?.long_name,
    city: place.city ? cityResolver(place.city) : null,
  }
}
